import $ from 'jquery';
import * as d3 from 'd3';

function isitChartable(data){
  for (let d of data){
    if ((d.stickerPriceOnCampus || d.stickerPriceOffCampus) && d.netPrice){
        return true;
      };
  }
}

export function runData(datafile, metric) {

  if (datafile[0][metric] > 0 && datafile[3][metric] > 0) {
      const healthMetrics = datafile.filter(function(yr) {
      if (yr.year == '18-19') {
        return false;
      } else {
        return true;
      }
    }).map(year => {
      // Determine most complete trend between on- and off-campus
      let stickerPriceType = 'price_instate_oncampus';
      let onCampusCount = 0;
      let offCampusCount = 0;

      if (offCampusCount > onCampusCount) {
        stickerPriceType = 'price_instate_offcampus_nofamily'
      } 
      const thisYear = {
        'timescale': year.year,
        'metrics': year[metric]
      }

      return thisYear;
  });



  const chartable = isitChartable(healthMetrics);

 // responsiveness
 let window_width = $(window).width();
 let fullWidth;
 let fullHeight;

 if (window_width >= 650){
   fullWidth = 120;
 } else if (window_width > 570 && window_width < 650) {
  fullWidth = 90;
 } else if (window_width <= 450) {
   fullWidth = 90;
 } else {
   fullWidth = 90;
 }

 const commas = d3.format(',');

 // set the dimensions and margins of the graph
 const margin = { top: 2, right: 15, bottom: 2, left: 20 };

 const width = fullWidth - margin.left - margin.right;
 const height = fullWidth/4;
        // || $('#sticker-price-chart').height() - margin.top - margin.bottom;

  // set the ranges
 const x = d3.scaleBand().rangeRound([0, width]),
     y = d3.scaleLinear().rangeRound([height - 4, 0]),
     z = d3.scaleOrdinal(['#036888','#D2392A','#D2392A','#D2392A']);

   z.domain(d3.keys(healthMetrics[0]).filter(function(key) {
     return key !== "timescale";
   }));

   const trends = z.domain().map(function(name) {
     return {
       name: name,
       values: healthMetrics.map(function(d) {
         return {
           timescale: d.timescale,
           value: +d[name]
         };
       })
     };
   });



 // define the line
 const line = d3.line()
   .x(function(d) { return x(d.timescale); })
   .y(function(d) { return y(d.value); });

 // scale the range of the priceData
 
 // nx.domain(datafile.map(d => d.timescale));

 // ny.domain([0, d3.max(trends, function(c) {
 //                               return d3.max(c.values, function(v) {return v.total;});
 //                             }) + 500
 //          ]).nice();

  const newTrends = trends.map((rate) => {
    rate.values = rate.values.filter((item) => {
      if (item.timescale != "19-20") {
        return !(isNaN(item.value))
      }
    });
    return rate;
  });

  x.domain(newTrends[0].values.map(d => d.timescale));
  y.domain([d3.min(newTrends, function(c) {
    return d3.min(c.values, function(v) {
      return v.value * 0.8;
    });
  }), d3.max(newTrends, function(c) {
    return d3.max(c.values, function(v) {
      return v.value * 1.1;
    });
  })]);

  var xaxis = d3.axisBottom()
                   .scale(x).tickValues(['08-09', '17-18']).tickFormat((d)=>{
                    d = d.split("-")
                    return '20' + d[1]
                   }).tickSizeOuter(0);

  var xline = d3.axisBottom().scale(x).tickValues([]).tickSizeOuter(0);

  const target = "#score-bar-score-" + metric
    const svg = d3.select(target)
                .append('svg')

    const g = svg.append("g")
        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

svg.append("svg:defs").append("svg:marker")
    .attr("id", "triangle")
    .attr("refX", 6)
    .attr("refY", 6)
    .attr("markerWidth", 30)
    .attr("markerHeight", 30)
    .attr("markerUnits","userSpaceOnUse")
    .attr("orient", "auto")
    .append("path")
    .attr("d", "M 0 0 12 6 0 12 3 6")
    .style("fill", "#697b9f");

     // Draw the line
 const trend = g.selectAll(".trend")
   .data(newTrends)
   .enter()
   .append("g")
   .attr("class", "trend");

 trend.append('text')
      .attr("x", (d)=>{
        return width - 5;
      })             
      .attr("y", (d)=>{

          if (y(d.values[8].value) < 15) {
            return y(d.values[8].value) + 14;
          } else {
            return y(d.values[8].value) - 10;
          }
        
      })
      .attr("text-anchor", "middle")  
      .style("font-size", "10px") 
      .style("font-weight", 300)
      .text((d)=>{
        if(d.values[8].value<=1){ 
          return Math.round(d.values[8].value * 100, 2) + '%'
        } else {
          return d.values[8].value
      }
    });

 trend.append("path")
   .attr("class", "line")
   .attr("d", (d) => {
     let keepValues = [];
     for(var i = 0; i < d.values.length; i++){
      keepValues.push(d.values[i]);
       }
     return line(keepValues);
   }).attr("marker-end", "url(#triangle)");

   trend
     .style("fill", "#697b9f")
     .style("stroke", '#697b9f')
     .attr("opacity", (d) => {
      if (d.name.includes('nyet')) {
        return .3;
      }
   })
  const el_name = "Total expenses";
  trend
   .selectAll("circle.line")
   .data((d) => {
       let keepValues = [];
       for(var i = 0; i < d.values.length; i++){
        if (d.name != el_name) {
          continue
         }
         if (isNaN(d.values[i].value) !== false || d.values[i].value !== 0){
           keepValues.push(d.values[i]);
         }
       }
       return keepValues;
     })
     .enter()
     .append("circle")
     .attr("r", 4)
     .style("stroke-width", 1)
     .style("stroke", "white")
     .style("fill", "black")
     .attr("cx", function(d) { 
      return x(d.timescale); })
     .attr("cy", function(d) { return y(d.value); });
  


    const timeScales = healthMetrics.map(function(name) { return x(name.timescale); });

  } else {
    $("#fever-line-" + metric).addClass("faded")
    $("#fever-line-" + metric + " > .score-bar-na").removeClass("invisible")
  }


 } // end rundata

 export default {runData}